import 'jquery-ui-npm/jquery-ui.min.js'
import 'react-toastify/dist/ReactToastify.css';

window.jQuery = window.$ = require("jquery");
window.moment = require('moment');
window._ = require('lodash');

require("bootstrap");

require.ensure([], () => {
  require('./app');
});



// WEBPACK FOOTER //
// ./src/indexApp.js